export class storageReference{
    public ID:number;
    public keyType:any;
    public keyName:string;
    constructor(id:number,keyT:any,keyN:string){
        this.ID = id;
        this.keyType = keyT;
        this.keyName=keyN;
    }
}